export const STORAGE_KEY = 'jwt-lms-smartx';
export const STORAGE_USER_ID = 'storage_user_id';
export const STORAGE_LEARNING_BY_USER_ID = 'storage_learning_';
